import Vue, { Fragment } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import axios from 'axios'
import '@/common/css/index.scss'
import './plugins/element.js'
import i18n from './plugins/i18n'

Vue.config.productionTip = false
Vue.http = Vue.prototype.$http = axios

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
